import * as yup from 'yup';

export default yup.object().shape({
  changepw: yup.string().required('변경할 비밀번호를 입력하세요.'),
});
